<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >

          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>


          <v-toolbar-title class="pageTitle">
            Neuigkeiten
          </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">

      <v-card
          class="news-card"
      >
        <v-list subheader v-for="(newsGroup, index) in news" :key="index" class="news-list">
          <v-subheader class="news-header" v-text="index"></v-subheader>

          <v-list-item
              class="news-list__item"
              v-for="news2 in newsGroup"
              :key="news2.id"
              @click="issueFileFetch(news2)"
          >

            <v-list-item-content>
              <v-list-item-title class="news-content" v-html="news2.description"></v-list-item-title>
              <v-list-item-subtitle class="news--content_info">
                <span>(PDF vom: {{ news2.published }})</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>

      <v-dialog persistent eager content-class="scannerDialog"
                attach=".v-application--wrap"
                v-bind:value="this.pdfDialog"
      >
        <v-card light class="three-color-grad pdfViewerCard">

          <v-btn
              class="pdfNewsCloseBtn closeBtn leftRounded"
              @click="closePDFViewer"
          >
            <close-btn/>
          </v-btn>

          <div class="pdf-dialog__container">

            <v-card class="pdf-dialog__viewer__wrapper">
              <vue-pdf-app v-show="this.pdf !== null" class="pdf-dialog__viewer" :config="pdfConfig" :pdf="this.pdf"
                           @pages-rendered="pagesRendered"
              >
              </vue-pdf-app>

              <v-progress-circular v-if="this.pdf === null"
                                   indeterminate
                                   color="red"
                                   class="pdf-progress-loader"
              />
              <div class="bottom-spacer-pdf"/>
            </v-card>
          </div>
        </v-card>
      </v-dialog>



      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import {mapActions, mapMutations} from 'vuex';
import CloseBtn from "@/assets/closeBtn";

import VuePdfApp from 'vue-pdf-app'
import "vue-pdf-app/dist/icons/main.css"

export default {
  name: "news",

  components: {
    VuePdfApp,
    CloseBtn
  },

  data() {
    return {
      isLoading: true,
      news: null,
      pdfDialog: false,
      pdf: null,

      newsId: null,

      pdfConfig: {
        toolbar: {
          toolbarViewerLeft: {
            findbar: false,
            previous: false,
            next: false
          },

          toolbarViewerMiddle: true,
          toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            viewBookmark: false,
            print: true,
            download: true
          },
        },
        secondaryToolbar: false,
        sidebar: false
      }
    }
  },

  methods: {
    ...mapActions({
      getNews: 'getNews',
      getNewsFile: 'getNewsFile'
    }),

    ...mapMutations({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    closePDFViewer() {
      this.pdfDialog = false
      this.pdf = null
    },

    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-fit"))
    },

    goBack() {
      router.go(-1)
    },

    issueFileFetch(data) {
      this.pdfDialog = true
      this.getNewsFile(data.id).then((resp) => {
        this.pdf = resp
      })
    }
  },

  mounted() {
    this.setHeaderVisibility(false)

    this.getNews().then((response) => {
      this.news = response
      this.isLoading = false
    })
  }
}
</script>

<style>
.pdf-app .pdfViewer .canvasWrapper {
  overflow: visible;
}

.pdf-app .textLayer {
  overflow: visible;
}
</style>
